<template>

  <div class="page_wrapper_inner">
    <h2 class="page_title">Lista želja</h2>

    <p v-if="getItems.length === 0" class="empty" >Vaša lista želja je prazna</p>

    <div class="wishlist_list">
      <div class="wishlist_item" v-for="(item, index) in getItems" :key="index">

        <a :href="item.path">
          <img :src="item.cartImage" :alt="item.short"  width="270" height="400">
        </a>
        <h2><a :href="item.path">{{ item.name }}</a></h2>
        <p>{{ formatPrice(item.price) }} rsd</p>

        <p v-if="item.is_available">Ima na stanju</p>
        <p v-else>Nema na stanju</p>

        <add-to-cart :product-code="item.code" v-if="item.is_available"></add-to-cart>
        <a class="add" v-else href="#">Pogledajte proizvode</a>

        <div class="remove" @click="remove(index)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><title>Ukloni proizvod</title><path fill="currentColor" d="M12 12h2v12h-2zM18 12h2v12h-2z"/><path fill="currentColor" d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zM12 2h8v2h-8z"/></svg>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import accounting from 'accounting';

  export default {
    name: "Wishlist",

    props: ['wishlistItems'],

    data: function () {
      return {
        getItems: this.wishlistItems,
      }
    },

    methods: {
      remove(index) {
        axios.post('/izbaci-iz-liste-zelja/' + index)
            .then(response => {

              this.$toasted.global.toastSuccess({message: response.data.message});
              this.getItems = response.data.wishListItems
            })
            .catch(e => {

            })
      },

      /**
       * Format price.
       *
       * @param value
       */
      formatPrice(value) {

        return accounting.formatMoney(value, '', 2, '.', ',')
      },
    }


  }
</script>
